import React, { useState } from "react";
import store from "../catalog/app/redux/store";
import * as Actions from "../catalog/app/redux/actions";
import ChangePassword from "./change-password";
import loginImg from "../assets/img/logo.png";
import closeEyeImg from "../assets/img/closeEye.png";
import openEyeImg from "../assets/img/openEye.png";

const Login = () => {
  const [checked, setChecked] = useState(false);
  const [forgetPwd, setForgetPwd] = useState(false);
  const [loginValue, setLoginValue] = useState("");
  const [pwdValue, setPwdValue] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [loginError, setLoginError] = useState(false);

  const handleChange = () => {
    setChecked(!checked);
  };

  const handleSubmitLogin = (event) => {
    event.preventDefault();
    
    store
      .dispatch(Actions.login(loginValue, pwdValue))
      .then((responseAction) => {
        if(responseAction.type === "LOGIN_ERROR") {

          setLoginError(true);
          store.dispatch(Actions.confirmAuth(false));

        }

        if (responseAction.type === Actions.USER_LOGED) {
          store.dispatch(Actions.confirmAuth(true));
        } else {
          store.dispatch(Actions.confirmAuth(false));
        }
      });
  };

  return (
    <div className="login">
      <div className="logo">
        <img src={loginImg}></img>
      </div>
      {forgetPwd ? (
        <ChangePassword setForgetPwd={setForgetPwd} />
      ) : (
        <div className="content">
          <form onSubmit={(e) => handleSubmitLogin(e)}>
            <div className="user-email">
              <input
                type="text"
                placeholder="E-mail"
                onChange={(e) => setLoginValue(e.target.value)}
              />
            </div>
            <div className="user-pwd">
              <input
                type={showPwd ? "text" : "password"}
                placeholder="Contraseña"
                onChange={(e) => setPwdValue(e.target.value)}
              />
              <span className="hide-pw">
                <span
                  className="dashicons dashicons-visibility"
                  onClick={() => setShowPwd(!showPwd)}
                >
                  <img src={showPwd ? openEyeImg : closeEyeImg} />
                </span>
              </span>
            </div>

            {loginError && <p className="loginError">Usuario o contraseña son incorrecto.</p>}
            <p className="submit">
              <input type="submit" value="Acceder" disabled={loginValue === "" && pwdValue === "" && true}/>
            </p>
          </form>
          <div className="nav" onClick={() => setForgetPwd(true)}>
            <div>¿Has olvidado tu contraseña?</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
